export const folderPaneToggle = "mSa";
export default {folderPaneToggle};